// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Comments-cls1__a03cabbadef88fe56f8e{/*!*/}.Comments-cls2__d35103ea1ee9cd406158{margin:-4px;padding:4px;line-height:20px;height:28px;color:#535366;color:var(--text-secondary, #535366);font-weight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Comments-cls1__a03cabbadef88fe56f8e",
	"cls2": "Comments-cls2__d35103ea1ee9cd406158 Comments-cls1__a03cabbadef88fe56f8e"
};
export default ___CSS_LOADER_EXPORT___;
